import {Component} from 'react'

import LoadingFreelance from '../../../../../components/Freelance/Component/LoadingFreelance/LoadingFreelance.jsx'
import DefaultLayout from '../../../../Layout/DefaultLayout.jsx'

class LoadingProfile extends Component {
  render() {
    return (
      <DefaultLayout>
        <div className="bg-gray-50">
          <div className="container container-profile-freelance">
            <div className="row">
              <div className="mx-auto col freelance-profile fl-pages">
                <LoadingFreelance />
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default LoadingProfile